module.exports = __webpack_public_path__ + "img/arrow_next_gray.e6b2912b.svg";